import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFilterComponent } from '../../../shared/date-filter/date-filter.component';

@Component({
  selector: 'app-filter-quotation-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, DateFilterComponent],
  templateUrl: './filter-quotation-modal.component.html',
})
export class FilterQuotationModalComponent implements OnInit {
  @Input() currentFilters: Partial<{
    text: string;
    startDate: Date | null;
    endDate: Date | null;
  }> | null = null;

  @Output() close = new EventEmitter<void>();
  @Output() applyFilters = new EventEmitter<{
    text: string;
    startDate: Date | null;
    endDate: Date | null;
  }>();

  filterText = '';
  startDate: Date | null = null;
  endDate: Date | null = null;

  ngOnInit() {
    if(this.currentFilters){
      this.filterText = this.currentFilters.text || '';
      this.startDate = this.currentFilters.startDate || null;
      this.endDate = this.currentFilters.endDate || null;
    }
  }

  onDateRangeSelected(range: { start: Date | null; end: Date | null }) {
    this.startDate = range.start;
    this.endDate = range.end;
  }

  apply() {
    this.applyFilters.emit({
      text: this.filterText,
      startDate: this.startDate,
      endDate: this.endDate,
    });
    this.close.emit();
  }
}
